module.exports = __webpack_public_path__ + "static/media/draggedSpreader.1fc6110d.png";